/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Slider from "react-slick";
// components
import Subnav from "../../components/Subnav/Subnav";
import { LessonBox } from "../../components/LessonItem/LessonItem";
import Banner from "../../components/Banner/Banner";
// styles
import "./Study.scss";
import "../../sass/slick.scss";
// data

import { useLessonContext } from "../../context/providers/LessonContext";
import { useFavoriteContext } from '../../context/providers/FavoriteContext';
import { showSuccessMessage, showErrorMessage } from '../../utils/notification';

const Study = (props) => {
	const { countLessons, lessonTotal, tipsTotal, pronunciationTotal, getLessons, lessons } = useLessonContext();
	const {success,error} = useFavoriteContext()
	React.useEffect(() => {
		getLessons(
			{
				page: 1,
				limit: 3,
			},
			"Beginner"
		);
		if (success !== null) {
			showSuccessMessage(success)
		}
		if (error !== null) {
			showErrorMessage(error)
		}
		countLessons();
	}, [success,error]);
	const sliderSettings = {
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		slideToShow: 1,
		slideToScroll: 1,
	};

	const recommendedSliderSettings = {
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		slideToShow: 3,
		slideToScroll: 1,
	};

	return (
		<div className="container container--main">
			{/*<div className="filters filters--primary d-flex">
				<div className="filters__item container--default fw--600 flex-auto active">Beginner</div>
				<div className="filters__item container--default fw--600 flex-auto">Intermediate</div>
				<div className="filters__item container--default fw--600 flex-auto">Advanced</div>
	</div>*/}
			<Slider className="mt-4" {...sliderSettings}>
				<Subnav
					item={{
						name: "Lessons",
						amountVideo: lessonTotal !== null && lessonTotal,
						path: "/lessons",
					}}
				/>
				<Subnav
					item={{
						name: "Pronunciations",
						amountVideo: pronunciationTotal !== null && pronunciationTotal,
						path: "/pronunciations",
					}}
				/>
				<Subnav
					item={{
						name: "Tips",
						amountVideo: tipsTotal !== null && tipsTotal,
						path: "/tips",
					}}
				/>
			</Slider>

			<Banner className="mt-4" {...props}></Banner>
			{lessons !== null && lessons.docs.length > 0 && (
				<Slider className="mt-4 slider--recommended" {...recommendedSliderSettings}>
					{lessons.docs.map((item, index) => {
						return (
							<div className="lessons container--default" key={index}>
								<LessonBox item={item}></LessonBox>
							</div>
						);
					})}
				</Slider>
			)}
		</div>
	);
};
export default Study;
